<template>
  <div style="display: inline;">
    <yi_curd_table :name="$options.name" ref="yt" getUrl="/web/craft/basic/work/procedure/user/price/page" getKey="rows" :columns="columns">
      <!-- 左侧按钮插槽 -->
      <template #buttonsL="scope">
        <el-button type="primary" size="mini" @click="yt.showEditDialog('xinzeng', null, 'w1')">
          {{ $t('xinzeng') }}
        </el-button>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('bianji', scope.row)">{{ $t('bianji') }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" :loading="yt.editObj.loading" class="font-color-danger" @click="yt.remove(scope.row, '/web/craft/basic/work/procedure/user/price/delete')">{{ $t('shanchu') }} </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('yonghumingcheng')" required>
            <yi_data_select type="customer_user" :ids.sync="yt.editObj.userId"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('danjia(yuan)')" required>
            <el-input-number :precision="4" :min="0" v-model="yt.editObj.price"></el-input-number>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" :loading="yt.editObj.loading" @click="yt.req('POST', '/web/craft/basic/work/procedure/user/price/create', beforeAdd)" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <template v-if="yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('yonghumingcheng')" required>
            <yi_data_select type="customer_user" :ids.sync="yt.editObj.userId" disabled> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('danjia(yuan)')" required>
            <el-input-number :precision="4" :min="0" v-model="yt.editObj.price"></el-input-number>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" :loading="yt.editObj.loading" @click="yt.req('POST', '/web/craft/basic/work/procedure/user/price/update')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script type="text/javascript">
export default {
  name: 'web_base_process_user_price',
  data() {
    return {
      columns: [
        {
          label: 'yonghumingcheng',
          prop: 'user.nickname'
        },
        {
          label: 'danjia(yuan)',
          prop: 'price'
        },
        {
          label: 'chuangjianren',
          prop: 'createByObject.nickname'
        },
        {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time'
        },
        {
          label: 'caozuo',
          type: 'slot',
          fixed: 'right',
          width: 150
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = {
        workProcedureId: this.$attrs.workProcedure.id
      };
      this.yt.get(1);
    }, 300);
  },
  methods: {
    beforeAdd(params, url) {
      params.workProcedureId = this.$attrs.workProcedure.id;
      return params;
    }
  }
};
</script>

<style scoped lang="scss"></style>
